/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { AppSchemasDbResourcesMediaType } from './appSchemasDbResourcesMediaType';
import type { ExportedResourceOutputUrl } from './exportedResourceOutputUrl';
import type { ExportedResourceOutputResourceId } from './exportedResourceOutputResourceId';
import type { ExportedResourceOutputResourceRef } from './exportedResourceOutputResourceRef';
import type { ExportedResourceOutputDigest } from './exportedResourceOutputDigest';

/**
 * Resource in export format
 */
export interface ExportedResourceOutput {
  title: string;
  description?: string;
  citation?: string;
  media_type: AppSchemasDbResourcesMediaType;
  url?: ExportedResourceOutputUrl;
  resource_id?: ExportedResourceOutputResourceId;
  resource_ref?: ExportedResourceOutputResourceRef;
  digest?: ExportedResourceOutputDigest;
  sort_order?: number;
  oral_exam_relevant?: boolean;
}
